import Vue from 'vue';
import store from '@/store';
import { encodePathSegment } from '@/utils/url';

export default (group) => {
  Vue.$http
    .delete(`CustomerGroups/${encodePathSegment(group.id)}`)
    .then(() => {
      store.dispatch('group/getGroup');
    })
    .catch((error) => {
      console.log(error);
    });
};



// WEBPACK FOOTER //
// ./src/services/group/del.js